<div *ngIf='menu'>

</div>

<div *ngIf="message!=null" class="alert alert-danger" role="alert">
  {{ message }}
  
</div>
<!-- <div class="d-md-flex h-md-100 align-items-start"> -->
<!-- <div class="col-md-6 p-0 bg-indigo h-md-100">
    <div class="text-white d-md-flex align-items-start h-100 p-5 text-center ">
      <div class="logoarea pt-5 pb-5"> -->
<ng-template navi>
</ng-template>

<!-- </div>
    </div>
  </div> -->
<!-- <div class="col-md-6 p-0 bg-white h-md-100">
    <div class="text-white d-md-flex align-items-start h-100 p-5 text-center ">
      <ng-template folders>
      </ng-template>

    </div>
  </div> -->

<!-- </div> -->